import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  widgets: {
    wins: 0,
    averageRank: 0,
    open: 0,
    upcoming: 0,
    loading: false,
  },
  open: {
    data: [],
    loading: false,
    count: 0,
  },
  upcoming: {
    data: [],
    loading: false,
    count: 0,
  },
  closed: {
    data: [],
    loading: false,
    count: 0,
  },
};

const compete = createSlice({
  name: "compete",
  initialState,
  reducers: {
    getWidgetsDataRequest(state) {
      state.widgets.loading = true;
    },
    getWidgetsDataSuccess(state, action) {
      state.widgets.wins = action.payload?.totalWinCompetition || 0;
      state.widgets.averageRank = action.payload?.averageWinCompetition || 0;
      state.widgets.open = action.payload?.totalOpenCompetition || 0;
      state.widgets.upcoming = action.payload?.totalUpcomingCompetition || 0;
      state.widgets.loading = false;
    },
    getWidgetsDataFailure(state) {
      state.widgets.loading = false;
    },
    getOpenCompetitionsRequest(state) {
      state.open.loading = true;
    },
    getOpenCompetitionsSuccess(state, action) {
      state.open.data = action.payload?.rows || [];
      state.open.count = action.payload?.count || 0;
      state.open.loading = false;
    },
    getOpenCompetitionsFailure(state) {
      state.open.loading = false;
    },
    getUpcomingCompetitionsRequest(state) {
      state.upcoming.loading = true;
    },
    getUpcomingCompetitionsSuccess(state, action) {
      state.upcoming.data = action.payload?.rows || [];
      state.upcoming.count = action.payload?.count || 0;
      state.upcoming.loading = false;
    },
    getUpcomingCompetitionsFailure(state) {
      state.upcoming.loading = false;
    },
    getClosedCompetitionsRequest(state) {
      state.closed.loading = true;
    },
    getClosedCompetitionsSuccess(state, action) {
      state.closed.data = action.payload?.rows || [];
      state.closed.count = action.payload?.count || 0;
      state.closed.loading = false;
    },
    getClosedCompetitionsFailure(state) {
      state.closed.loading = false;
    },
    addUserToCompetition(state, action) {
      if (action.payload.open) {
        const competitions = [...state.open.data];
        const competitionIndex = state.open.data.findIndex(
          (competition) => competition.id === action.payload.competitionId
        );
        if (competitionIndex !== -1) {
          competitions?.[competitionIndex]?.CompetitionMembers?.push({
            userId: action.payload.userId,
          });
        }
      } else {
        const competitions = [...state.upcoming.data];
        const competitionIndex = state.upcoming.data.findIndex(
          (competition) => competition.id === action.payload.competitionId
        );
        if (competitionIndex !== -1) {
          competitions?.[competitionIndex]?.CompetitionMembers?.push({
            userId: action.payload.userId,
          });
        }
      }
    },
  },
});
export const competeAction = compete.actions;
export default compete.reducer;
